import { shadows } from "../../theme/base";
import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: darkColors.backgroundAlt,
    text: darkColors.text,
    boxShadow: shadows.tooltip
};
export var dark = {
    background: lightColors.backgroundAlt,
    text: lightColors.text,
    boxShadow: shadows.tooltip
};
